import { render } from "./OrbitParticlesSize.vue?vue&type=template&id=d6eacd52"
import script from "./OrbitParticlesSize.vue?vue&type=script&lang=js"
export * from "./OrbitParticlesSize.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__